module.exports = {
      id: "charge-l4-usage",
      viewBox: "0 0 45 20",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#charge-l4-usage",
      toString: function () {
        return this.url;
      }
    }